import type { SVGAttachment, SVGSourceData } from "./svg-config";
import type { SVGLine } from "./svg";

function unCamelCase(val: string) {
    return val
        .replace(/([A-ZĀĒĪŌŪ])/g, (pu) => ` ${pu}`)
        .replace(/^(\w)/, (pu) => pu.toUpperCase());
}

export function getGenericSVGLines(data: SVGSourceData): SVGLine[] {
    const svgLines: SVGLine[] = [{ heading: "Other" }];
    for (const attr of Object.keys(data)) {
        const label = unCamelCase(attr);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = (data as any)[attr];

        if (Array.isArray(text)) {
            const files = text as SVGAttachment[];
            let index = 0;
            for (const file of files) {
                const thisLabel = `${label}${index ? ` ${index}` : ""}`;
                svgLines.push({ label: thisLabel, text: file.name });
                index += 1;
            }
        } else {
            svgLines.push({ label, text });
        }
    }

    if (svgLines.length === 1) {
        return ([] as unknown) as SVGLine[];
    }

    return svgLines;
}
